import { render, staticRenderFns } from "./PageDetail.vue?vue&type=template&id=5b9ec61f&"
import script from "./PageDetail.vue?vue&type=script&lang=js&"
export * from "./PageDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/views/PageDetail.vue"
export default component.exports